import MacleJSBridge from 'src/bridges';
import { IAnyStrObject } from 'src/types';
import { reportErrorLog } from '../utils';

export type NativeCallback = (res: any) => any;

// h5调用native原生方法
export function callNativeAPI(
  apiName: string,
  inputParams: IAnyStrObject = {},
  successCb: NativeCallback,
  failCb: NativeCallback = defaultFailCb,
) {
  const callbacks = [successCb, failCb];
  const invalidCallback = callbacks.find(cb => !cb || typeof cb !== 'function');

  if (invalidCallback) {
    reportErrorLog(apiName, 'callback should be function!');
    return;
  }
  MacleJSBridge.invoke(apiName, inputParams, (invokeStatusCode, res) => {
    const isOk = Number(invokeStatusCode) === 0;
    if (!isOk) {
      reportErrorLog(apiName, `${res.errMsg}`);
      failCb(res);
      return;
    }
    successCb(res);
  });
}

function defaultFailCb() {}
